module.exports = __webpack_public_path__ + "img/titulo-metricas.d4799dfa.png";